<div class="modal-header"><h2 class="modal-title">Cash Breakdown</h2></div>
<div class="modal-body">
  <table class="cash-table">
    @for (item of items; track item) {
      <tr>
        <td class="label-col">{{ item.label }}</td>
        <td class="count-col"><input type="number" min="0" [(ngModel)]="item.count" [readOnly]="mode === 'summary'" class="form-control" onmousewheel="return false;" /></td>
        <td class="total-col"><input [value]="item.total | currency" tabindex="-1" class="form-control" readonly /></td>
      </tr>
    }
    <tr class="total-row">
      <td class="label-col">Total</td>
      <td class="count-col"></td>
      <td class="total-col"><input [value]="calcTotal() | currency" tabindex="-1" class="form-control" readonly /></td>
    </tr>
  </table>
</div>
<div class="modal-footer">
  @if(mode !== 'summary') {
    <button class="btn btn-success" (click)="save()">Save</button>
  }
  <button class="btn btn-default" (click)="cancel()">{{mode === 'summary' ? 'Close' : 'Cancel'}}</button>
</div>
